import Fetch from "./index";

export const getChatInstance = async ({ assistantID, chatbotID } = {}) => {
    if (!assistantID && !chatbotID)
        return Promise.reject("failed to read id");

    const url = assistantID
        ? "/chat-integration/assistant/"+assistantID
        : "/chat-integration/chatbot/"+chatbotID;

    return Fetch(url);
}

export const createChatInstance = async ({ assistantID, chatbotID } = {}, body) => {
    if (!assistantID && !chatbotID)
        return Promise.reject("failed to read id");

    const data = new FormData();
    if (assistantID) data.set("assistantID", assistantID);
    if (chatbotID) data.set("chatbotID", chatbotID);
    if (body) {
        for (const key in body) {
            data.set(key, body[key]);
        }
    }

    const url = "/chat-integration";

    return Fetch(url, {
        method: 'POST',
        body: data,
    });
}

export const deleteChatInstance = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/chat-integration/" + id, {
        method: 'DELETE',
        headers: {
            "Content-Type": "application/json",
        }
    });
}

export const updateChatInstance = async (id, body) => {
    if (!id)
        return Promise.reject("failed to read id");

    const { createdAt, updatedAt, deletedAt, id: _, ...cleanBody } = body;

    const data = new FormData();
    for (const key in cleanBody) {
        data.set(key, cleanBody[key]);
    }

    return Fetch("/chat-integration/" + id, {
        method: 'PUT',
        body: data,
    });
}
